import api from '../api';

export const getBcmPhases = () => api.get('maturity/bcm/phases/');
export const loadBcmPhase = (phaseId) => api.get(`maturity/bcm/phase/${phaseId}/load/`);

export const saveBcmPhase = (phaseId, payload) =>
  api.post(`maturity/bcm/phase/${phaseId}/save/`, payload);

export const submitBcmPhase = (phaseId, payload) =>
  api.post(`maturity/bcm/phase/${phaseId}/submit/`, payload);